<template>
  <div
    class="kpi-card bg-white dark:bg-darkblue-800 rounded-xl p-4 border border-primary-100 dark:border-darkblue-600 shadow-sm">
     <header v-if="hasHeader" class="mb-2 text-base text-secondary-800 dark:text-darkblue-100 font-medium">
        <slot name="header"/>
     </header>
     <main class="text-secondary-600 dark:text-darkblue-200 flex flex-col justify-evenly" :class="{'h-full':expand}">
        <slot name="default"/>
        <slot name="content"/>
     </main>
     <footer v-if="hasFooter" class="mt-1 text-sm text-secondary-500 dark:text-darkblue-300">
        <slot name="footer"/>
      </footer>
  </div>
</template>
<script>
export default {
  name: 'base-panel',
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasHeader () {
      return !!this.$slots.header || !!this.$scopedSlots.header
    },
    hasFooter () {
      return !!this.$slots.footer || !!this.$scopedSlots.footer
    }
  }
}
</script>
<style scoped>
.kpi-card {
  transition: transform 0.2s, box-shadow 0.2s;
}
/* .kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(2,117,170,0.12);
} */
</style>
<style>
  .my-3 {
    margin-top: 0.75rem /* 12px */;
    margin-bottom: 0.75rem /* 12px */;
}
  .mx-3 {
    margin-left: 0.75rem /* 12px */;
    margin-right: 0.75rem /* 12px */;
  }
  .px-5 {
    padding-left: 1.25rem /* 20px */;
    padding-right: 1.25rem /* 20px */;
}
</style>
